import styled from "styled-components";

export const ContentModalSaveSurveyAnswer = styled.div`
  position: absolute;
  left: 35.2%;
  right: 35.2%;
  top: 7.64%;
  bottom: 75.77%;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  height: fit-content;

  @media only screen and (max-width: 768px) {
    width: 60%;
    left: 20%;
  }
  .button-container {
    display: flex;
  }
`;

export const ButtonSurveyAnswer = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  margin: 1em auto;
  color: white;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const ButtonCancelSurvey = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: ${({ theme }) => theme.neutral.gray[1500]};
  border-radius: 4px;
  border: none;
  margin: 1em auto;
  color: white;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
`;
export const TextModalSurveyAnswer = styled.div`
  padding: 1em;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  text-align: center;
  svg {
    font-size: xx-large;
  }
`;

export const CloseModalSurveyAnswer = styled.div`
  height: 2em;
  width: 100%;
  text-align: end;
  padding: 0.3em 1em;
  font-weight: 600;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  a {
    color: ${({ theme }) => theme.primary.purple};
    text-decoration: none;
    background-color: transparent;
  }
`;
export const SizeImgRating = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  flex-direction: row-reverse;
  svg {
    height: 30px !important;
    width: 10% !important;
    cursor: pointer;
  }
  .ImageRating:hover,
  .ImageRating:hover ~ .ImageRating {
    fill: #ffc502 !important;
  }
`;
